import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { UserInfoService } from './user-info-service';
import { IScreens } from './IScreens';
import { IRoles } from '../interfaces/IRoles';
import { IRole } from 'src/app/core/authentication-local/irole';
import { IRolesScreens } from '../interfaces/IRolesScreens';


@Injectable({
  providedIn: 'root',
})
export class RolService extends RestCallService {

  public DataToSend: IRoles = {
		pk_role: 0,
		name: '',
		creation_date: new Date(),
		str_creation_date: '',
		fk_employee_creator: 1,
		last_updated: new Date(),
		str_last_updated: '',
		fk_employee_updater: 1,
		fk_record_status: 1,
		employee_creator_name: '',
		employee_updater_name: '',
		username: '',
		record_status_name: '',
		check: false,
		available: false,
		fk_site: 0,
		editable: false,
	};


  public rolesScreens: IRolesScreens = {
		fk_role: 0,
		fk_screen: 0,
		fk_site: 0,
		username: '',
		available: false,
		orders: [],
		screen: '',
	};



  constructor(
    public httpClient: HttpClient,
    public toastr: ToastrService,
    public notificationService: NotificationService,
    public translate: TranslateApplicationService,
    private userInfoService: UserInfoService
  ) {
    super(
      httpClient,
      'LockerLinkApi',
      toastr,
      notificationService,
      translate,
    );
  }

  public getList() {
    return this.get<IRole[]>('Role/GetRoles');
  }

  public getActive() {
    return this.get<IRole[]>('Role/GetActiveRoles');
  }

  public createRol(data: IRole) {
    return this.post('Role/CreateRol', data);
  }

  public updateRol(data: IRole) {
    return this.put('Role/UpdateRol', data);
  }

  public GetRoleByUser() {
    this.DataToSend.username = this.userInfoService.windowsNT;
    this.DataToSend.fk_site = this.userInfoService.pk_site;
		return this.post<IRoles>('/api/Roles/GetRoleByUser', this.DataToSend);
	}

  public GetScreensByUsername() {
    this.DataToSend.username = this.userInfoService.windowsNT;
    this.DataToSend.fk_site = this.userInfoService.pk_site == null ? 0: this.userInfoService.pk_site;
		return this.post<IScreens[]>('/api/Roles/GetScreensByUsername',this.DataToSend);
	}
}
